"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BA = void 0;
exports.BA = {
    numericCode: '070',
    alpha2Code: 'BA',
    alpha3Code: 'BIH',
    englishName: {
        short: 'Bosnia and Herzegovina',
        full: 'Bosnia and Herzegovina',
    },
    names: {
        full: {
            bs: 'Bosna i Hercegovina',
            en: 'Bosnia and Herzegovina',
            fr: 'Bosnie-Herzégovine (la)',
            hr: 'Bosna i Hercegovina',
            sr: 'Bosna i Hercegovina',
        },
        short: {
            bs: 'Bosna i Hercegovina',
            en: 'Bosnia and Herzegovina',
            fr: 'Bosnie-Herzégovine (la)',
            hr: 'Bosna i Hercegovina',
            sr: 'Bosna i Hercegovina',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'bs',
            languageAlpha3Code: 'bos',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'hr',
            languageAlpha3Code: 'hrv',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'sr',
            languageAlpha3Code: 'srp',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'BA-BIH': {
            numericCode: '070',
            code: 'BA-BIH',
            category: {
                id: '237',
                names: {
                    bs: {
                        singular: 'entitet',
                        plural: '',
                    },
                    en: {
                        singular: 'entity',
                        plural: 'entities',
                    },
                    fr: {
                        singular: 'entité',
                        plural: '',
                    },
                    hr: {
                        singular: 'entitet',
                        plural: '',
                    },
                    sr: {
                        singular: 'entitet',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bs: 'Federacija Bosne i Hercegovine',
                hr: 'Federacija Bosne i Hercegovine',
                sr: 'Federacija Bosne i Hercegovine',
            },
        },
        'BA-SRP': {
            numericCode: '070',
            code: 'BA-SRP',
            category: {
                id: '237',
                names: {
                    bs: {
                        singular: 'entitet',
                        plural: '',
                    },
                    en: {
                        singular: 'entity',
                        plural: 'entities',
                    },
                    fr: {
                        singular: 'entité',
                        plural: '',
                    },
                    hr: {
                        singular: 'entitet',
                        plural: '',
                    },
                    sr: {
                        singular: 'entitet',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bs: 'Republika Srpska',
                hr: 'Republika Srpska',
                sr: 'Republika Srpska',
            },
        },
        'BA-BRC': {
            numericCode: '070',
            code: 'BA-BRC',
            category: {
                id: '438',
                names: {
                    bs: {
                        singular: 'distrikt',
                        plural: '',
                    },
                    en: {
                        singular: 'district with special status',
                        plural: 'districts with special status',
                    },
                    fr: {
                        singular: 'district',
                        plural: '',
                    },
                    hr: {
                        singular: 'distrikt',
                        plural: '',
                    },
                    sr: {
                        singular: 'distrikt',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                bs: 'Brčko distrikt',
                hr: 'Brčko distrikt',
                sr: 'Brčko distrikt',
            },
        },
    },
    cities: [
        {
            name: 'Zenica',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Visoko',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Velika Kladuša',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Tuzla',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Trebinje',
            subdivision: 'Republika Srpska',
        },
        {
            name: 'Travnik',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Sarajevo',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Prijedor',
            subdivision: 'Republika Srpska',
        },
        {
            name: 'Mostar',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Gradačac',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Gračanica',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Goražde',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Doboj',
            subdivision: 'Republika Srpska',
        },
        {
            name: 'Cazin',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Bugojno',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Brčko',
            subdivision: 'Brčko',
        },
        {
            name: 'Bosanska Krupa',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Bijeljina',
            subdivision: 'Republika Srpska',
        },
        {
            name: 'Bihać',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
        {
            name: 'Banja Luka',
            subdivision: 'Republika Srpska',
        },
        {
            name: 'Konjic',
            subdivision: 'Federation of Bosnia and Herzegovina',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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